import Link from "next/link";
import { CLOUD_PATH } from "@/components/homepage/paintPaths";

type CloudButtonProps = {
  href: string;
  label: string;
  color: string;
  className?: string;
};

export default function CloudButton({ href, label, color, className = "" }: CloudButtonProps) {
  return (
    <Link
      href={href}
      className={`group relative block aspect-[300/154] w-full text-white transition hover:-translate-y-1 focus-visible:outline-none ${className}`}
    >
      <svg
        viewBox="0 0 300 154"
        preserveAspectRatio="none"
        className="absolute inset-0 h-full w-full"
        aria-hidden="true"
      >
        <path d={CLOUD_PATH} fill={color} />
        {/* Same path scaled about the centre, so the dashes follow the lobes. */}
        <path
          d={CLOUD_PATH}
          fill="none"
          stroke="#ffffff"
          strokeWidth={4}
          strokeDasharray="14 10"
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
          transform="translate(150 77) scale(0.9) translate(-150 -77)"
        />
        <path
          d={CLOUD_PATH}
          fill="none"
          stroke="#2d2729"
          strokeWidth={3}
          className="opacity-0 transition-opacity group-focus-visible:opacity-100"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      {/* Absolutely positioned so the label can never drive the box height —
          with aspect-ratio set, content height would otherwise dictate width. */}
      <span className="absolute inset-0 grid place-items-center px-[13%] text-center text-base font-extrabold leading-tight xl:text-xl">
        {label}
      </span>
    </Link>
  );
}
